import { Injectable, TemplateRef } from '@angular/core';
import { NzSafeAny } from 'ng-zorro-antd/core/types';

interface IMTemplateRefs {
  [key: string]: TemplateRef<NzSafeAny>;
}

@Injectable()
export class MOperationsTemplateService {
  operationsRef: Partial<IMTemplateRefs> = {};

  add(name: string, ref: TemplateRef<NzSafeAny>): void {
    this.operationsRef[name] = ref;
  }

  getTemplateRef(refName: string): TemplateRef<NzSafeAny> | undefined {
    return this.operationsRef[refName];
  }
}
